import ReactDOM from 'react-dom'
import { App } from './App'
import * as serviceWorker from './serviceWorker'

let apiEnv = ''

// @ts-ignore
window.renderHouseScan = (rootId: string, environment: string, contractDisabled?: boolean, leadsource: number, directFlow?: string) => {
  apiEnv = environment
  ReactDOM.render(<App contractDisabled={!!contractDisabled} leadsource={leadsource} directFlow={directFlow} />, document.getElementById(rootId))
}

/*ReactDOM.render(<App contractDisabled={false} leadsource={179} />, document.getElementById('root'))*/

serviceWorker.unregister()

export { apiEnv }
